<template>
  <div class="summary-container">
    <div class="agreement-container">
      <h2>Credit Check</h2>
      <p>
        Please enter your BVN to check if you are eligible for this service.
      </p>

      <modal-sucess
        v-if="modalSucess"
        @close="modalSucess = false"
        :message="messageSuccess"
      ></modal-sucess>

      <modal-error
        v-if="showModalError"
        :modalstateError="messageModal"
        @close="showModalError = false"
      ></modal-error>

      <form>
        <h4>Bank Verification Number (BVN)</h4>
        <input-field v-model="form.bvn" :error="formErrors.bvn" />
      </form>

      <div v-if="loader" className="text-center">
        <div class="download-button">
          <div
            class="spinner-border"
            style="width: 2rem; height: 2rem"
            role="status"
          >
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
      <div v-else>
        <button @click="makeRequest" class="download-button" type="button">
          Make Request
        </button>
      </div>
    </div>
    <div class="illustration">
      <div class="description">
        Kindly input your BVN to enable us run a credit check
      </div>
      <img
        :src="require('../../../../assets/img/polygon.svg')"
        class="polygon"
        alt="Comment Bubble"
      />
      <img :src="require('../../../../assets/img/male-tablet.gif')" alt="" />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import InputField from "../components/InputField.vue";
import ModalSucess from "../../kitchen/Onboarding/ModalSuccess.vue";
import ModalError from "../../kitchen/Onboarding/modal-error.vue";
import VueSweetalert2 from "vue-sweetalert2";
import Vue from "vue";
import "sweetalert2/dist/sweetalert2.min.css";

Vue.use(VueSweetalert2);

export default {
  name: "CreditCheck",
  props: ["updateStatus", "updateTracker", "markAsCompleted"],
  components: {
    InputField,
    ModalError,
    VueSweetalert2,
    ModalSucess
  },
  computed: {},
  data() {
    return {
      loader: false,
      message: "",
      showModalError: false,
      messageSuccess: "You have passed the credit check stage",
      modalSucess: false,
      stage: "",
      messageModal: "",
      form: {
        bvn: ""
      },
      formErrors: {},
      // activeIndex: 0,
      summary: {}
    };
  },
  notifications: {
    showSuccessMsg: {
      type: "success",
      title: "Success",
      message: "Success Msg!"
    },
    showInfoMsg: {
      type: "info",
      title: "Information",
      message: "Info. Msg!"
    },
    showWarnMsg: {
      type: "warning",
      title: "Warning",
      message: "Warning Msg!"
    },
    showErrorMsg: {
      type: "error",
      title: "Error",
      message: "Error Msg!"
    }
  },
  methods: {
    gotoCreditCheck() {
      this.$emit("updateStatus");
    },
    showAlert() {
      // Use sweetalert2
      // this.$swal.fire({title: 'Success', imageWidth: '40px', text: 'You have passed the Credit Check stage', icon:'success', width: '550px'});
    },
    bankRequestPassed() {
      // return true;
      return this.summary.statementpassed ? true : false;
    },
    gotoNextState() {
      this.$emit("updateStatus");
    },
    validateInputs() {
      const formErrors = [];

      //
      for (let [field, value] of Object.entries(this.form)) {
        value = value + "";
        if (value !== "null" && value !== Number.isInteger(value)) {
          value = value.trim();
        }

        switch (field) {
          case "bvn":
            if (value === "null" || value === "") {
              formErrors[field] = "Bank cannot be empty.";
            }
            break;
          default:
            break;
        }
      }
      return formErrors;
    },
    async makeRequest() {
      this.formErrors = this.validateInputs();
      if (Object.keys(this.formErrors).length > 0) return;

      const data = {
        bvn: this.form.bvn,
        customerid: localStorage.customerId
      };

      this.loader = true;
      this.$emit("showLoading", true);
      const HTTP = this.$httpUtils.FASTHTTP;
      try {
        let res = await HTTP.post("/creditcheck/check-credit-rating", data);
        this.$emit("showLoading", false);
        this.loader = false;

        if (res.data.isPerforming === true) {
          this.showSuccessMsg({ message: "Credit Check Passed!" });
          this.markAsCompleted(true);
          setTimeout(() => {
            this.gotoNextState();
          }, 2000);
          this.updateStateFunc();
          return;
        } else {
          this.showErrorMsg({ message: res.data.message });
        }
      } catch (error) {
        console.log(error);
        this.loader = false;
        this.$emit("showLoading", false);
        this.showErrorMsg({
          message: "Unable to complete action, please try again"
        });
      }
    },
    updateStateFunc() {
      const payloadData = {
        stateid: 3
      };
      const HTTP = this.$httpUtils.FASTHTTP;
      HTTP.patch("/onboardingstate/nextstate", payloadData).then(res => {
        this.$store.commit("saveOnboanrdingState", 3);

        if (res.data) {
          // this.showAgreement = false
        }
      });
    }
  },
  mounted() {
    this.updateTracker(true);
    this.updateStatus(3);
  }
};
</script>

<style lang="scss" scoped>
@import "../../../../assets/scss/_reduced_variables.scss";

h1,
h2,
h3,
h4,
p {
  margin: 0;
  padding: 0;
  font-family: "DM Sans", sans-serif;
  font-weight: 400;
}

p {
  color: #727272;
  font-size: 16px;
  line-height: 24px;
}

h2 {
  color: #0892d0;
  margin-bottom: 18px;
  font-weight: 700;
}

h3 {
  font-weight: 700;
  font-size: 16px;
  color: #000000;
  margin: 20px 0px;
}

h4 {
  font-weight: 700;
  font-size: 16px;
  color: #fe7a11;
  margin: 62px 0px 13px;
}

.summary-container {
  display: flex;
  justify-content: space-between;
}

.download-button {
  border-radius: 5px;
  padding: 14px 36px;
  text-align: center;
  max-width: 240px;
  background: #fe7a11;
  border: 1px solid #fe7a11;
  color: #ffffff;
  margin-right: 35px;
  cursor: pointer;
}

.summary {
  h2 {
    color: #0892d0;
    margin-bottom: 30px;
    font-weight: 700;
  }

  .summary-table {
    padding: 0px 28px;
    background: #fafafa;
    width: 70%;

    > div {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      padding: 24px 0px;
      border-bottom: 1px dashed #e8e2e2;

      p:last-child {
        text-align: right;
        width: 50%;
      }

      &:last-child {
        border-bottom: none;
      }
    }

    .table-base p {
      font-weight: bold;
    }
  }
}

.illustration {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  max-width: 350px;

  img:first-child {
    margin-bottom: -3rem;
    z-index: 3;
  }
}

.description {
  max-width: 340px;
  border-radius: 40px;
  padding: 32px 20px;
  background: #e6f6ff;
  text-align: center;
  font-family: "DM Sans";
  font-style: normal;
  font-weight: 700;
  font-size: 16px;
  line-height: 22px;
  color: #0892d0;
}

.polygon {
  width: 5.3rem;
  height: 5.8rem;
  margin-left: 21rem;
  margin-top: -1.5rem;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/onboarding/leaseToOwn/CreditCheck.vue